import React from "react";
import "./components/MortgageTools.css";

const tools = [
  {
    id: "emi-calculator",
    icon: "bi bi-calculator",
    image: "/images/FrontPage/calculate.jpg",
    imageAlt: "Loan EMI calculator",
    label: "Loan Planning",
    title: "EMI Calculator",
    description:
      "Estimate your monthly EMI, total interest and overall loan repayment.",
    link: "https://app.mortbuzz.in/Mortbuzz-emi-calculater.html",
    buttonText: "Calculate EMI",
    external: true,
  },
  {
    id: "loan-comparison",
    icon: "bi bi-bar-chart",
    image: "/images/FrontPage/loan-compare-scaled.jpg",
    imageAlt: "Compare different loan options",
    label: "Loan Comparison",
    title: "Compare Loans",
    description:
      "Compare suitable loan options, interest rates and repayment details.",
    link: "https://app.mortbuzz.in/mortbuzz-home-loan-compare.html",
    buttonText: "Compare Loans",
    external: true,
  },
  {
    id: "loan-eligibility",
    icon: "bi bi-person-check",
    image: "/images/FrontPage/eligibility-scaled.jpg",
    imageAlt: "Check loan eligibility",
    label: "Eligibility Check",
    title: "Check Eligibility",
    description:
      "Get an estimate of the loan amount you may be eligible to receive.",
    link: "https://app.mortbuzz.in/Mortbuzz-loan-eligibility.html",
    buttonText: "Check Eligibility",
    external: true,
  },
  {
    id: "car-loan",
    icon: "bi bi-car-front",
    image: "/images/FrontPage/car-loan-mustang.png",
    imageAlt: "Car loan information",
    label: "Vehicle Finance",
    title: "Car Loan",
    description:
      "Explore car loan options with competitive rates and flexible repayment.",
    link: "/car-loan",
    buttonText: "Explore Car Loan",
    external: false,
  },
];

const MortgageTools = () => {
  return (
    <section
      className="mortgage-tools-section"
      aria-labelledby="mortgage-tools-title"
    >
      <div
        className="mortgage-tools-glow mortgage-tools-glow-left"
        aria-hidden="true"
      ></div>

      <div
        className="mortgage-tools-glow mortgage-tools-glow-right"
        aria-hidden="true"
      ></div>

      <div className="mortgage-tools-container">
        <div className="mortgage-tools-header">
          <span className="mortgage-tools-eyebrow">
            Smart Financial Tools
          </span>

          <h2 id="mortgage-tools-title">
            Plan your loan with
            <span> helpful financial tools</span>
          </h2>

          <p>
            Use Monayra’s calculators and comparison tools to understand your
            EMI, eligibility and suitable loan options before applying.
          </p>
        </div>

        <div className="mortgage-tools-grid">
          {tools.map((tool, index) => (
            <article className="mortgage-tool-card" key={tool.id}>
              <div className="mortgage-tool-card-border"></div>

              <div className="mortgage-tool-image-wrapper">
                <img
                  src={tool.image}
                  alt={tool.imageAlt}
                  className="mortgage-tool-image"
                  loading="lazy"
                />

                <div className="mortgage-tool-image-overlay"></div>

                <span className="mortgage-tool-number">
                  {String(index + 1).padStart(2, "0")}
                </span>

                <span className="mortgage-tool-icon">
                  <i className={tool.icon}></i>
                </span>
              </div>

              <div className="mortgage-tool-content">
                <span className="mortgage-tool-label">
                  {tool.label}
                </span>

                <h3>{tool.title}</h3>

                <p>{tool.description}</p>

                <a
                  href={tool.link}
                  className="mortgage-tool-button"
                  target={tool.external ? "_blank" : undefined}
                  rel={tool.external ? "noopener noreferrer" : undefined}
                  aria-label={`${tool.buttonText}${
                    tool.external ? " in a new tab" : ""
                  }`}
                >
                  <span>{tool.buttonText}</span>

                  <i
                    className={
                      tool.external
                        ? "bi bi-box-arrow-up-right"
                        : "bi bi-arrow-right"
                    }
                  ></i>
                </a>
              </div>
            </article>
          ))}
        </div>

        <div className="mortgage-tools-footer">
          <div className="mortgage-tools-trust-item">
            <i className="bi bi-shield-check"></i>
            Secure calculations
          </div>

          <div className="mortgage-tools-trust-item">
            <i className="bi bi-lightning-charge"></i>
            Instant estimates
          </div>

          <div className="mortgage-tools-trust-item">
            <i className="bi bi-headset"></i>
            Expert assistance
          </div>
        </div>

        <div className="mortgage-tools-disclaimer">
          <i className="bi bi-info-circle"></i>

          <p>
            Calculations and eligibility results are indicative. Final loan
            approval, rates and terms depend on lender policies and the
            applicant’s financial profile.
          </p>
        </div>
      </div>
    </section>
  );
};

export default MortgageTools;